export default __webpack_public_path__ + "static/media/logoVisuality.89e3aba7.png";